import { render, staticRenderFns } from "./review.vue?vue&type=template&id=3c4fb0ae"
import script from "./review.vue?vue&type=script&lang=ts"
export * from "./review.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports